// src/pages/ServiceDetail.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FaArrowLeft,
  FaCheckCircle,
  FaClock,
  FaTools,
  FaShieldAlt
} from "react-icons/fa";
import Navbar from "../Navbar";
import PageBanner from "../Pagebanner";

const productData = {
  "1": {
    title: "Electrical Materials",
    description: "Complete range of electrical components and materials for all types of installations",
    image: "https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=400&h=300&fit=crop",
    badge: "Main Product",
    features: ["Cables & Wires", "Switches & Sockets", "Circuit Breakers", "Distribution Panels"]
  },
  "2": {
    title: "Industrial Explosion Proof Materials",
    description: "Specialized materials designed for hazardous industrial environments",
    image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=400&h=300&fit=crop",
    badge: "Industrial Grade",
    features: ["Explosion Proof Enclosures", "Hazardous Area Lighting", "Safety Switches", "Certified Components"]
  },
  "3": {
    title: "Hardware Materials",
    description: "Quality hardware solutions for construction and maintenance needs",
    image: "https://images.unsplash.com/photo-1530124566582-a618bc2615dc?w=400&h=300&fit=crop",
    badge: "Durable",
    features: ["Bolts & Fasteners", "Hand Tools", "Power Tools", "Construction Hardware"]
  },
  "4": {
    title: "Plumbing Materials",
    description: "Comprehensive plumbing solutions including PVC products and fittings",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop",
    badge: "Complete Range",
    features: ["PVC Pipes & Fittings", "Water Tanks", "Pumps & Valves", "Bathroom Fixtures"]
  },
  "5": {
    title: "Consumable Materials",
    description: "Daily use materials and supplies for ongoing operations",
    image: "https://images.unsplash.com/photo-1586864387967-d02ef85d93e8?w=400&h=300&fit=crop",
    badge: "Essential",
    features: ["Adhesives & Sealants", "Cleaning Supplies", "Office Supplies", "Maintenance Items"]
  },
  "6": {
    title: "PPE Products",
    description: "Personal Protective Equipment for workplace safety",
    image: "https://images.unsplash.com/photo-1584464491033-06628f3a6b7b?w=400&h=300&fit=crop",
    badge: "Safety First",
    features: ["Safety Helmets", "Protective Clothing", "Safety Gloves", "Eye Protection"]
  },
  "7": {
    title: "Computer Accessories",
    description: "Modern technology accessories for office and industrial use",
    image: "https://images.unsplash.com/photo-1518717758536-85ae29035b6d?w=400&h=300&fit=crop",
    badge: "Tech Solutions",
    features: ["Cables & Adapters", "Storage Devices", "Network Equipment", "Computer Parts"]
  },
  "8": {
    title: "Steel Products",
    description: "High-quality steel materials for construction and fabrication",
    image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&h=300&fit=crop",
    badge: "Strong & Reliable",
    features: ["Structural Steel", "Steel Sheets", "Steel Bars", "Custom Fabrication"]
  },
  "9": {
    title: "GI Products",
    description: "Galvanized Iron products for corrosion resistance",
    image: "https://images.unsplash.com/photo-1565564669988-ba1d0e22cded?w=400&h=300&fit=crop",
    badge: "Corrosion Resistant",
    features: ["GI Pipes", "GI Sheets", "GI Fittings", "Galvanized Hardware"]
  },
  "10": {
    title: "Paints & Coatings",
    description: "Wall paints and waterproofing solutions for all surfaces",
    image: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=400&h=300&fit=crop",
    badge: "Quality Finish",
    features: ["Wall Paints", "Waterproofing Liquids", "Primers", "Specialty Coatings"]
  }
};

const serviceData = {
  "1": {
    title: "Electrical Material Mapping & Installation",
    image: "https://fastly.picsum.photos/id/20/3670/2462.jpg?hmac=CmQ0ln-k5ZqkdtLvVO23LjVAEabZQx2wOaT4pyeG10I",
    content:
      "We provide detailed mapping and efficient installation of electrical materials for residential and commercial buildings. Our certified electricians ensure safety, compliance, and high performance with every project.",
    highlights: [
      "Comprehensive Material Planning",
      "Professional Installation",
      "Safety Standards Compliance",
      "Project Documentation"
    ],
    badge: "Professional",
    details: {
      mapping: "Planning and documentation process where all required electrical materials are identified, listed, and allocated based on project design and site layout.",
      installation: "Physical process of installing electrical materials at specified locations, following approved electrical drawings and safety standards."
    }
  },
  "2": {
    title: "Building Maintenance",
    image: "https://fastly.picsum.photos/id/20/3670/2462.jpg?hmac=CmQ0ln-k5ZqkdtLvVO23LjVAEabZQx2wOaT4pyeG10I",
    content:
      "From plumbing to painting, our building maintenance service covers all aspects to ensure your property stays in top condition. We offer preventive maintenance and quick repairs.",
    highlights: [
      "Waterproofing Solutions",
      "Routine Maintenance",
      "Preventive Care",
      "Quality Assurance"
    ],
    badge: "Comprehensive",
    details: {
      waterproofing: "Critical waterproofing services for roofing, basements, bathrooms, and external walls.",
      routine: "Daily, weekly, and monthly maintenance tasks including floor maintenance, lighting, and equipment lubrication.",
      areas: ["Roofing", "Basements", "Bathrooms", "External Walls"]
    }
  },
  // "3": {
  //   title: "Emergency Maintenance",
  //   image: "https://fastly.picsum.photos/id/20/3670/2462.jpg?hmac=CmQ0ln-k5ZqkdtLvVO23LjVAEabZQx2wOaT4pyeG10I",
  //   content:
  //     "Need urgent help? Our emergency maintenance team is available 24/7 to fix critical issues like electrical faults, water leaks, or structural damage to keep your premises safe.",
  //   highlights: [
  //     "24/7 Quick Response",
  //     "Critical Repairs Handled Fast",
  //     "Fully Equipped Mobile Teams",
  //   ],
  // },
};

export default function ServiceDetail() {
  const { serviceId } = useParams();
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [activeTab, setActiveTab] = useState([]);

  useEffect(() => {
    if (serviceId && serviceData[serviceId]) {
      setServices([{ id: serviceId, ...serviceData[serviceId] }]);
    } else {
      const allServices = Object.entries(serviceData).map(([id, s]) => ({
        id,
        ...s,
      }));
      setServices(allServices);
    }
  }, [serviceId]);

  if (serviceId && services.length === 0) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100">
        <Navbar />
        <h1 className="text-3xl font-semibold text-red-600 mt-10">
          🚫 Service Not Found
        </h1>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-yellow-50 to-yellow-100">
      <div className="container mx-auto px-6 py-10">
        {/* <Navbar /> */}
        <PageBanner
          title="Services"
          breadcrumb="Home / Services"
          backgroundImage="/images/industry.jpg"
        />
        {serviceId && (
          <button
            onClick={() => navigate("/service")}
            className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-800 font-semibold mb-6 transition-colors duration-200"
          >
            <FaArrowLeft className="text-base" />
            <span>Back to All Services</span>
          </button>
        )}

        {/* {!serviceId && (
          <h2 className="text-4xl font-extrabold text-center text-primary mb-6">
            Our Services
          </h2>
        )} */}

        <div className="space-y-20 mt-16">
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              className="bg-white rounded-3xl shadow-xl overflow-hidden grid grid-cols-1 lg:grid-cols-2 gap-6 hover:shadow-2xl transition-all duration-300"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
            >
              {/* Image from Left */}
              <motion.img
                src={service.image}
                alt={service.title}
                className="w-full h-full object-cover max-h-[500px]"
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
              />

              {/* Text from Right */}
              <motion.div
                initial={{ opacity: 0, x: 100 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
                className="p-8 flex flex-col justify-center"
              >
                <h1 className="text-3xl lg:text-4xl font-bold text-[#0E324C] mb-4">
                  {service.title}
                </h1>
                <p className="text-gray-600 text-lg leading-relaxed mb-4">
                  {service.content}
                </p>
                <ul className="mt-4 space-y-3">
                  {service.highlights?.map((point, idx) => (
                    <li
                      key={idx}
                      className="flex items-start gap-3 text-gray-800 text-base"
                    >
                      <span className="text-green-500 mt-1">✔</span>
                      {point}
                    </li>
                  ))}
                </ul>
              </motion.div>
            </motion.div>
          ))}
        </div>

        {/* Radial Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-radial from-transparent via-primary/50 to-primary"></div>
      </div>

      <div className="relative container mx-auto px-4 py-8">
        {/* Header Section */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <motion.h2
            className="text-5xl md:text-6xl font-bold text-white mb-6"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Products &
            <span className="text-secondary ml-4">Services</span>
          </motion.h2>
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: "150px" }}
            transition={{ delay: 0.5, duration: 0.8 }}
            className="h-1 bg-gradient-to-r from-secondary to-yellow-300 mx-auto rounded-full mb-6"
          />
          <motion.p
            className="text-gray-300 text-lg max-w-3xl mx-auto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            Discover our comprehensive range of quality products and professional services designed to meet all your maintenance and construction needs
          </motion.p>
        </motion.div>

        {/* Tab Navigation */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="flex justify-center mb-12"
        >
          <div className="bg-white/10 backdrop-blur-md rounded-full p-2 shadow-2xl border border-white/20">
            <button
              onClick={() => setActiveTab('products')}
              className={`px-8 py-3 rounded-full font-semibold transition-all duration-300 ${activeTab === 'products'
                ? 'bg-secondary text-primary shadow-lg transform scale-105'
                : 'text-white hover:bg-white/10'
                }`}
            >
              Our Products
            </button>
            <button
              onClick={() => setActiveTab('services')}
              className={`px-8 py-3 rounded-full font-semibold transition-all duration-300 ${activeTab === 'services'
                ? 'bg-secondary text-primary shadow-lg transform scale-105'
                : 'text-white hover:bg-white/10'
                }`}
            >
              Our Services
            </button>
          </div>
        </motion.div>

        {/* Products Section */}
        {activeTab === 'products' && (
          <motion.div
            key="products"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 mb-20"
          >
            {Object.entries(productData).map(([id, product]) => (
              <motion.div
                key={id}
                variants={cardVariants}
                whileHover={{ y: -12, scale: 1.05 }}
                className="group bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl overflow-hidden hover:shadow-3xl transition-all duration-500 border border-white/20"
              >
                {/* Product Image */}
                <div className="relative overflow-hidden h-48">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary/80 to-transparent" />

                  {/* Badge */}
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 rounded-full text-xs font-semibold text-primary bg-secondary shadow-lg">
                      {product.badge}
                    </span>
                  </div>

                  {/* Overlay Content */}
                  <div className="absolute bottom-4 left-4 right-4">
                    <h3 className="text-xl font-bold text-white group-hover:text-secondary transition-colors duration-300">
                      {product.title}
                    </h3>
                  </div>
                </div>

                <div className="p-6">
                  {/* Description */}
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {product.description}
                  </p>

                  {/* Features */}
                  <div className="space-y-2 mb-6">
                    {product.features.map((feature, idx) => (
                      <motion.div
                        key={idx}
                        className="flex items-center gap-3"
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: idx * 0.1 }}
                      >
                        <FaCheckCircle className="text-secondary text-sm flex-shrink-0" />
                        <span className="text-gray-700 text-sm">{feature}</span>
                      </motion.div>
                    ))}
                  </div>

                  {/* CTA */}
                  <motion.button
                    whileHover={{ scale: 1.05, boxShadow: "0 10px 25px rgba(254, 208, 41, 0.3)" }}
                    whileTap={{ scale: 0.95 }}
                    className="w-full py-3 bg-gradient-to-r from-primary to-primary-dark text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:bg-gradient-to-r hover:from-primary-dark hover:to-primary"
                  >
                    View Products
                  </motion.button>
                </div>
              </motion.div>
            ))}
          </motion.div>
        )}

        {/* Services Section */}
        {activeTab === 'services' && (
          <motion.div
            key="services"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="space-y-20"
          >
            {Object.entries(serviceData).map(([id, service], index) => (
              <motion.div
                key={id}
                variants={serviceCardVariants}
                whileHover={{ y: -8, scale: 1.02 }}
                className="group bg-white/95 backdrop-blur-md rounded-3xl shadow-2xl overflow-hidden hover:shadow-3xl transition-all duration-500 border border-white/20"
              >
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
                  {/* Image Section */}
                  <div className="relative overflow-hidden">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover min-h-[400px] lg:min-h-[500px] group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-primary/60 to-transparent" />

                    {/* Floating Badge */}
                    <motion.div
                      initial={{ opacity: 0, scale: 0 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ delay: 0.8 }}
                      className="absolute top-6 left-6"
                    >
                      <span className="px-4 py-2 rounded-full text-primary text-sm font-semibold bg-secondary shadow-lg">
                        {service.badge}
                      </span>
                    </motion.div>

                    {/* Decorative Elements */}
                    <div className="absolute bottom-6 right-6 w-16 h-16 bg-secondary/20 rounded-full animate-pulse"></div>
                  </div>

                  {/* Content Section */}
                  <div className="p-8 lg:p-12 flex flex-col justify-center relative">
                    {/* Background Decoration */}
                    <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-secondary/10 to-secondary/5 rounded-full -translate-y-16 translate-x-16"></div>

                    <motion.h1
                      className="text-3xl lg:text-4xl font-bold text-primary mb-6 leading-tight"
                      initial={{ opacity: 0, x: 30 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.3 }}
                    >
                      {service.title}
                    </motion.h1>

                    <motion.p
                      className="text-gray-600 text-lg leading-relaxed mb-8"
                      initial={{ opacity: 0, x: 30 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.4 }}
                    >
                      {service.content}
                    </motion.p>

                    {/* Highlights */}
                    <div className="space-y-4 mb-8">
                      <h3 className="text-xl font-semibold text-primary">Key Features:</h3>
                      {service.highlights.map((point, idx) => (
                        <motion.div
                          key={idx}
                          className="flex items-start gap-4 group/item"
                          initial={{ opacity: 0, x: -20 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ delay: 0.5 + idx * 0.1 }}
                        >
                          <FaCheckCircle className="text-secondary text-lg mt-1 group-hover/item:scale-110 transition-transform duration-200" />
                          <span className="text-gray-700 font-medium group-hover/item:text-primary transition-colors duration-200">
                            {point}
                          </span>
                        </motion.div>
                      ))}
                    </div>

                    {/* Service Details */}
                    {service.details && (
                      <motion.div
                        className="bg-gradient-to-r from-primary/5 to-secondary/5 rounded-xl p-6 mb-8 border border-secondary/20"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.8 }}
                      >
                        <h4 className="font-semibold text-primary mb-4">Service Details:</h4>
                        {Object.entries(service.details).map(([key, value]) => (
                          <div key={key} className="mb-3">
                            <span className="text-sm font-medium text-secondary capitalize">{key.replace(/([A-Z])/g, ' $1')}: </span>
                            {Array.isArray(value) ? (
                              <ul className="mt-1 ml-4">
                                {value.map((item, idx) => (
                                  <li key={idx} className="text-gray-600 text-sm">• {item}</li>
                                ))}
                              </ul>
                            ) : (
                              <span className="text-gray-600 text-sm">{value}</span>
                            )}
                          </div>
                        ))}
                      </motion.div>
                    )}

                    {/* CTA Button */}
                    <motion.button
                      whileHover={{
                        scale: 1.05,
                        boxShadow: "0 15px 30px rgba(254, 208, 41, 0.4)"
                      }}
                      whileTap={{ scale: 0.95 }}
                      className="px-8 py-4 bg-gradient-to-r from-secondary to-yellow-400 text-primary font-bold rounded-full shadow-lg hover:shadow-xl transition-all duration-300 w-fit hover:from-yellow-400 hover:to-secondary"
                    >
                      Get Quote Now
                    </motion.button>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        )}
      </div>
    </div>
  );
}